export default __webpack_public_path__ + "static/media/segre02.8d477ad1.jpg";